import axios from "axios";

export const getGoogleUserInfo = (accessToken: string) => {
  return axios.get("https://www.googleapis.com/oauth2/v2/userinfo", {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};
